import React from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

const TermsOfServiceModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header with Close Button */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-2xl font-bold text-gray-900">Terms of Service</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
            aria-label="Close"
          >
            <X size={24} />
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="flex-grow overflow-y-auto px-6 py-4">
          <div className="space-y-4 text-sm text-gray-700">
            <p>
              By accessing or using Ordinaa's software applications, platforms, and services ("Services"), you agree to be bound by these Terms of Service.
            </p>

            <div>
              <h3 className="font-bold text-gray-900 mb-2">Use of Services</h3>
              <ul className="list-disc list-inside space-y-1 ml-2">
                <li>The Services are provided for business and enterprise use only</li>
                <li>You must use the Services in compliance with applicable laws and contractual obligations</li>
                <li>You are responsible for maintaining the confidentiality of your account credentials</li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-gray-900 mb-2">Customer Data</h3>
              <ul className="list-disc list-inside space-y-1 ml-2">
                <li>Customers retain full ownership of their data</li>
                <li>Ordinaa acts solely as a service provider and data processor</li>
                <li>You are responsible for ensuring you have the rights to upload and process any data</li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-gray-900 mb-2">Intellectual Property</h3>
              <ul className="list-disc list-inside space-y-1 ml-2">
                <li>All software, models, designs, and platform components remain the property of Ordinaa</li>
                <li>No rights are granted except as expressly stated</li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-gray-900 mb-2">Service Availability</h3>
              <ul className="list-disc list-inside space-y-1 ml-2">
                <li>Services are provided on an "as is" and "as available" basis</li>
                <li>We may modify, suspend, or improve features to enhance service quality</li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-gray-900 mb-2">Limitation of Liability</h3>
              <p>
                To the maximum extent permitted by law, Ordinaa shall not be liable for indirect, incidental, or consequential damages.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-gray-900 mb-2">Termination</h3>
              <ul className="list-disc list-inside space-y-1 ml-2">
                <li>Either party may terminate access in accordance with applicable agreements</li>
                <li>Upon termination, data handling will follow contractual and privacy commitments</li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-gray-900 mb-2">Changes to Terms</h3>
              <ul className="list-disc list-inside space-y-1 ml-2">
                <li>We may update these Terms from time to time</li>
                <li>Continued use of the Services constitutes acceptance of updated terms</li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-gray-900 mb-2">Contact</h3>
              <p>
                For questions regarding these Terms, contact us at:
              </p>
              <div className="space-y-1">
                <p>
                  Email: contact@ordinaa.com
                </p>
                <p>
                  Phone: +91 9380470079
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Us Button - Bottom */}
        <div className="px-6 pb-4 pt-2 border-t border-gray-200">
          <Link
            to="/contact"
            className="w-full px-4 py-2 bg-cyan-600 text-white rounded-lg font-semibold hover:bg-cyan-700 transition-colors text-center text-sm block"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServiceModal;
